export type EvidenceStatusKind = 'snap' | 'clip' | 'meta';

export function evidenceStatusChipMeta(kind: EvidenceStatusKind, status: string) {
  const normalized = (status || 'PENDING').toUpperCase();
  if (normalized === 'AVAILABLE') {
    return {
      label: kind === 'snap' ? 'Snapshot available' : kind === 'clip' ? 'Clip available' : 'Context ready',
      color: 'success' as const,
    };
  }
  if (normalized === 'FAILED') {
    return {
      label: kind === 'snap' ? 'Snapshot failed' : kind === 'clip' ? 'Clip failed' : 'Context failed',
      color: 'error' as const,
    };
  }
  if (normalized === 'MISSING' || normalized === 'UNAVAILABLE') {
    return {
      label: kind === 'snap' ? 'No snapshot' : kind === 'clip' ? 'No video' : 'No context',
      color: 'default' as const,
    };
  }
  if (normalized === 'PENDING') {
    return {
      label: kind === 'snap' ? 'Snapshot pending' : kind === 'clip' ? 'Clip pending' : 'Context pending',
      color: 'warning' as const,
    };
  }
  return { label: `${kind}: ${normalized}`, color: 'default' as const };
}
